import React from "react";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useWatch } from "react-hook-form";
import { Message } from "semantic-ui-react";
import useInspectionType from "../../../../../tanstack/inspection-types/useInspectionType";
import { Time, CalendarDate, getDayOfWeek } from "@internationalized/date";
import { BlockOutDay, BlockOutDayDoWToJSDateDoW } from "../../scheduler/utils/InspectionTypeBlockOutDay";

export default function BlockOutDayWarningMessage({
  inspectionTypeId,
}: {
  inspectionTypeId: string | number | undefined;
}) {
  const { data } = useInspectionType({
    id: inspectionTypeId ?? "",
    enabled: !!inspectionTypeId,
  });
  const blockOutDays = data?.data.attributes.blockOutDays ?? [];

  const inspectionDateFormData = useWatch<CalendarDate | null>({ name: "inspectionDate" });
  const inspectionTimeFormData = useWatch<Time | "AM" | "PM" | null>({ name: "inspectionTime" });

  const inspectionTimeOrMeridiem = inspectionTimeFormData;
  const scheduledDate = inspectionDateFormData;
  if (scheduledDate === null) {
    return <></>;
  }

  const selectedTimeIsAM =
    !inspectionTimeOrMeridiem ||
    inspectionTimeOrMeridiem === "AM" ||
    (inspectionTimeOrMeridiem !== "PM" && inspectionTimeOrMeridiem.hour < 12);
  const selectedTimeIsPM =
    !inspectionTimeOrMeridiem ||
    inspectionTimeOrMeridiem === "PM" ||
    (inspectionTimeOrMeridiem !== "AM" && inspectionTimeOrMeridiem.hour >= 12);

  const amBlockedOut = scheduledDate ? isAMBlockedOut(scheduledDate, blockOutDays) : false;
  const pmBlockedOut = scheduledDate ? isPMBlockedOut(scheduledDate, blockOutDays) : false;

  const isSelectedDateAndTimeBlockedOut = (amBlockedOut && selectedTimeIsAM) || (pmBlockedOut && selectedTimeIsPM);
  if (!isSelectedDateAndTimeBlockedOut) {
    return <></>;
  }

  return (
    <Message className='tw-border-[#c9ba9b] tw-bg-[#fffaf3] tw-text-[#573a08]'>
      <FontAwesomeIcon size='xl' icon={faTriangleExclamation} /> Your scheduling on a blockout day
    </Message>
  );
}

function isPMBlockedOut(date: CalendarDate, blockOutDays: BlockOutDay[]): boolean {
  return blockOutDays.some((day) => {
    const isPMBlockedOut = day.meridiem === "PM" || day.meridiem === null;
    return BlockOutDayDoWToJSDateDoW[day.dayOfWeek] === getDayOfWeek(date, "en-US") && isPMBlockedOut;
  });
}

function isAMBlockedOut(date: CalendarDate, blockOutDays: BlockOutDay[]): boolean {
  return blockOutDays.some((day) => {
    const isPMBlockedOut = day.meridiem === "AM" || day.meridiem === null;
    return BlockOutDayDoWToJSDateDoW[day.dayOfWeek] === getDayOfWeek(date, "en-US") && isPMBlockedOut;
  });
}
